<template>
  <div id="line-of-supervision-form">
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- BEGIN: Form Layout -->
        <div class="intro-y box p-5">

          <div class="mt-3">
            <label for="name" class="form-label"><span class="text-danger">*</span> 名稱</label>
            <input v-model="form.name" id="name" type="text" class="form-control w-full" placeholder="請輸入名稱">
            <div v-if="'name' in errors" class="text-danger mt-2" v-html="errors.name"></div>
          </div>

          <div class="mt-3">
            <label for="url" class="form-label"><span class="text-danger">*</span> 網址</label>
            <input v-model="form.url" id="url" type="text" class="form-control w-full" placeholder="請輸入網址">
            <div v-if="'url' in errors" class="text-danger mt-2" v-html="errors.description"></div>
          </div>

          <div class="mt-3">
            <label for="is_open_newwindow" class="form-label">開新視窗</label>
            <div class="form-switch">
              <input id="is_open_newwindow" v-model="form.is_open_newwindow" type="checkbox" class="form-check-input">
            </div>
            <div v-if="'is_open_newwindow' in errors" class="text-danger mt-2" v-html="errors.is_open_newwindow"></div>
          </div>

          <div class="mt-3">
            <label for="display_order" class="form-label">顯示次序</label>
            <input v-model="form.display_order" id="display_order" type="number" class="form-control w-full" placeholder="請輸入顯示次序">
            <div v-if="'display_order' in errors" class="text-danger mt-2" v-html="errors.display_order"></div>
          </div>

          <div class="mt-3">
            <label for="is_effective" class="form-label">公開</label>
            <div class="form-switch">
              <input id="is_effective" v-model="form.is_effective" type="checkbox" class="form-check-input">
            </div>
            <div v-if="'is_effective' in errors" class="text-danger mt-2" v-html="errors.is_effective"></div>
          </div>

          <div class="flex justify-end align-items-center mt-5">
            <router-link v-if="!loading && !finish" to="/management/menu-shortcut" type="button" class="btn btn-outline-secondary w-24 mr-1">取消</router-link>
            <button v-if="!loading && !finish" type="button" class="btn btn-primary w-24" @click="onSave">儲存</button>
            <span v-show="loading && !finish"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>
        </div>
        <!-- END: Form Layout -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['currentSite', 'data'],
  data() {
    return {
      mode: 'create',
      form: {
        title: null,
        url: null,
        is_open_newwindow: false,
        display_order: 0,
        is_effective: true
      },
      errors: {},
      loading: false,
      finish: false
    }
  },
  watch: {
    data(val) {
      this.init()
    }
  },
  mounted() {
    window.tailwind.svgLoader()
    this.init()
  },
  methods: {
    init() {
      if (this.data != null) {
        this.form = this.data
        this.mode = 'update'
      }
    },
    onSave: async function() {
      this.loading = true
      this.errors = {}

      let response

      if (this.mode === 'create') {
        response = await this.createSiteMenuShortcut(this.currentSite.site_id, this.form)
      } else {
        response = await this.updateSiteMenuShortcut(this.currentSite.site_id, this.data.shortcut_id, this.form)
      }

      if ('errors' in response.data) {
        this.errors = response.data.errors
        this.loading = false
      } else {
        let option = {
          title: (this.mode === 'create') ? '已成功新增捷徑' : '已成功更新捷徑',
          message: '請稍後，將會轉至最捷徑頁面',
          type: 'success'
        }

        this.$root.$children[0].loadMenuItems()

        if (response.code === 0) {
          this.finish = true

          setTimeout(() => {
            this.$router.push('/management/menu-shortcut')
          }, 1000)
        } else {
          this.loading = false
          option = {
            title: (this.mode === 'create') ? '未能新增捷徑' : '未能更新捷徑',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
